/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_Revoke_Success_DescriptionInputs */

const es_user_profile_devices_revoke_success_description = /** @type {(inputs: User_Profile_Devices_Revoke_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El dispositivo fue eliminado correctamente`)
};

const en_user_profile_devices_revoke_success_description = /** @type {(inputs: User_Profile_Devices_Revoke_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The device was removed successfully`)
};

/**
* | output |
* | --- |
* | "The device was removed successfully" |
*
* @param {User_Profile_Devices_Revoke_Success_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_revoke_success_description = /** @type {((inputs?: User_Profile_Devices_Revoke_Success_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_Revoke_Success_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_revoke_success_description(inputs)
	return en_user_profile_devices_revoke_success_description(inputs)
});
export { user_profile_devices_revoke_success_description as "user.profile.devices.revoke.success_description" }